import { MovieOpenStarIcon } from './MovieOpenStarIcon';

/**
 * author: Colton Wiscombe
 * id D370E43D-3692-4654-B67E-12AA40956EF3
 * name movie-open-star
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-star.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardOpenStarIcon = MovieOpenStarIcon;
export default ClapperboardOpenStarIcon